
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lms/teacher-dashboard-prototype",
      function () {
        return require("private-next-pages/lms/teacher-dashboard-prototype/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lms/teacher-dashboard-prototype"])
      });
    }
  